import React, { useContext, useEffect, useState } from 'react'
import { CButton, CModal, CModalBody, CModalHeader } from '@coreui/react'
import CustomDescriptionBox from 'src/components/CustomDescriptionBox'
import ImageUploader from 'src/components/ImageUploader/ImageUploader'
import { GlobalContext } from 'src/views/context/GlobalState'
import { getThumbnail } from 'src/views/utils/helper'
import Loading from 'react-fullscreen-loading'
import { AppContext } from 'src/views/context/app'
import AttachLink from '../attachLink'

const AdNCarouselCardModal = ({
  cancelCardModal,
  slideObj,
  addCallback,
  updateCallback,
  isEdit,
  categoryList,
}) => {
  const { loader } = useContext(AppContext)
  const { userSessionObj } = useContext(GlobalContext)
  const [imageS3key, setImageS3key] = useState('')
  const [heading, setHeading] = useState('')
  const [description, setDescription] = useState('')
  const [link, setLink] = useState({
    type: '',
    data: {},
  })

  const [errorData, setErrorData] = useState({})
  const [imageData, setImageData] = useState([])

  useEffect(() => {
    const imgData = [
      {
        title: '',
        id: 'mainImg',
        width: 307,
        height: 172,
        divwidth: '11.56rem',
        divheight: '7rem',
        assetId: '',
        setAssetId: (id) => {},
        setImage: (obj) => {
          clearError('imageS3key')
          setImageS3key(obj?.s3Key)
        },
        onRemoveImg: () => {
          setImageS3key('')
        },
        imageUrl: '',
        imagePaddingX: '6px',
        imagePaddingY: '6px',
        titleDisabled: true,
        uploadIconflexRow: true,
        uploadIconsize: '7px',
        btnMarginTop: '5px',
      },
    ]

    if (isEdit) {
      setHeading(slideObj.heading)
      setDescription(slideObj.description)
      setImageS3key(slideObj.image_s3key)
      setLink(slideObj.link)
      imgData[0]['assetId'] = slideObj.image_s3key
      imgData[0]['imageUrl'] = getThumbnail(
        userSessionObj?.session_data?.cf_domain_name,
        slideObj.image_s3key,
      )
    }

    setImageData(imgData)
  }, [])

  const clearError = (type) => {
    let temp = errorData
    temp[`${type}`] = ''
    setErrorData({ ...temp })
  }

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (imageS3key.trim().length === 0) {
      isFormValid = false
      temp.imageS3key = 'Upload Image!'
    }

    if (heading.trim().length === 0) {
      isFormValid = false
      temp.heading = 'Heading cannot be blank !'
    }

    setErrorData({ ...temp })
    return isFormValid
  }

  const handleSave = () => {
    if (!validateInfo()) return

    let dataObj = {
      image_s3key: imageS3key,
      heading: heading,
      description: description,
      link: link,
    }

    isEdit ? updateCallback(dataObj) : addCallback(dataObj)

    cancelCardModal()
  }

  return (
    <CModal
      size="lg"
      className="category-card-modal"
      alignment="center"
      visible={true}
      backdrop={true}
    >
      <Loading loading={loader} background={'rgba(60, 60, 60, 0.6)'} loaderColor="#efefef" />
      <CModalHeader
        style={{ borderBottom: 0, paddingBottom: 0 }}
        className="d-flex justify-content-center align-items-center"
      >
        <p style={{ fontSize: '20px' }}>
          <b style={{ fontWeight: '500' }}>Card Editor</b>
        </p>
      </CModalHeader>
      <CModalBody className="">
        <div className="py-3 px-5">
          <div>
            <div className="px-1 mb-3 text-center d-inline-block">
              <h6 style={{ fontSize: '13px', textAlign: 'left' }}>Add Image</h6>
              <ImageUploader data={imageData} />
              <span className="mt-2" style={{ fontSize: '10px', color: '#707070' }}>
                305px X 172px
              </span>
              <div className="message-text error-message">
                <p>{errorData.imageS3key}&#10240;</p>
              </div>
            </div>
            <div>
              <h6 style={{ fontSize: '13px' }}>Heading</h6>
              <CustomDescriptionBox
                limit={55}
                rows={1}
                value={heading}
                onChange={(value) => {
                  clearError('heading')
                  setHeading(value)
                }}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                useFormInput={true}
                isMandatory={true}
                errorText={errorData?.heading}
              />
            </div>
            <div>
              <h6 style={{ fontSize: '13px' }}>Paragraph</h6>
              <CustomDescriptionBox
                limit={170}
                rows={3}
                value={description}
                onChange={(value) => setDescription(value)}
                style={{ fontSize: '12px' }}
                limitFontSize={'11px'}
                // useFormInput={true}
              />
            </div>
            <div>
              <AttachLink
                linkData={link}
                id={'link1'}
                selectorWidth={'80%'}
                categoryData={categoryList}
                setLinkData={(value) => {
                  clearError('link')
                  setLink(value)
                }}
              />
            </div>
          </div>
        </div>
        <div className="py-2 px-4 d-flex justify-content-end">
          <CButton
            style={{ color: 'black', border: '1px solid black', fontSize: '1.1rem' }}
            className="mx-4 bg-white rounded-1 btn-focus-none"
            onClick={() => {
              cancelCardModal()
            }}
          >
            Cancel
          </CButton>
          <CButton
            style={{ fontSize: '1.1rem' }}
            className=" bg-black rounded-1 btn-focus-none px-3"
            onClick={handleSave}
          >
            Save
          </CButton>
        </div>
      </CModalBody>
    </CModal>
  )
}

export default AdNCarouselCardModal
